import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { NTabs, NTabPane } from "naive-ui";
import { ref, watch, nextTick } from "vue";
import setList from "@/components-m/set-list/index.vue";
import { TabsInst } from "naive-ui";

export default /*#__PURE__*/_defineComponent({
  props: ["setsData", "maxLength", "tabValue"],
  setup(__props) {

const props = __props


// type set = {
//   title: string,
//   name: string,
//   id: string
// }
const valueRef = ref(props.tabValue);
const tabsInstRef = ref<TabsInst | null>(null);

watch(
  () => props.tabValue,
  (params) => {
    console.log(params);
    valueRef.value = params;
    nextTick(() => tabsInstRef.value!.syncBarPosition());
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NTabs), {
    "justify-content": "space-evenly",
    type: "line",
    animated: "",
    placement: "left",
    class: "set-m",
    value: valueRef.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((valueRef).value = $event)),
    ref_key: "tabsInstRef",
    ref: tabsInstRef
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.setsData, (set, index) => {
        return (_openBlock(), _createBlock(_unref(NTabPane), {
          name: `${set.name}`,
          tab: set.title,
          key: index
        }, {
          default: _withCtx(() => [
            _createVNode(setList, {
              id: set.id,
              keyword: set.keyword,
              maxLength: props.maxLength
            }, null, 8, ["id", "keyword", "maxLength"])
          ]),
          _: 2
        }, 1032, ["name", "tab"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})